<template>
	<div :aria-busy="loading ? 'true' : 'false'">

	<modal-generic :conditional="confirm" :button-text="'sim'" :title-head="'Tem certeza que deseja enviar essa mensagem para a lixeira?'"
	@close="confirm = $event" @confirm="replyIssue($event,issue.id)">
	</modal-generic>

		<section class="content__custom" v-if="!loading">
			<div class="main-title">
				<h1 v-show="issue.open" class="messages">
					{{ 'message' | translate | titleCase }}
				</h1>
				<h1 v-show="issue.reply" class="messages">
					{{ 'replied-message' | translate | titleCase }}
				</h1>
				<h1 v-show="issue.ignored" class="messages">
					{{ 'ignored-message' | translate | titleCase }}
				</h1>
			</div>
			<div class="boxes">
				<div class="box">
					<div class="box__container">
						<div class="box__header">
							<div class="box__header__title">
								<div class="user">
									<div class="user__image">
										<img ref="userUrl"
											:src="issue.recipient.profile_picture"
											class="img-circle"
											alt="User Image"
											v-if="issue.recipient.profile_picture"
											@error="imageLoadOnError"
										/>
									</div>
									<div class="user__informations">
										<p class="user_name">{{issue.recipient.name}}</p>
										<p :title="'date-of-interaction' | translate">{{issue.created_at | date }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="box__body">
							<div class="box__body__message">
								<div class="form__group">
									<h2>{{ 'message' | translate | capitalize }}</h2>
									<p>{{issue.message}}</p>
								</div>
							</div>

							<div class="box__body__content__area" v-show="issue.reply">
								<div class="reply-message">
									<h2>{{ 'reply' | translate | capitalize }}</h2>
									<p>{{issue.reply}}</p>
								</div>
								<div v-if="issue.saved_attachment_id || issue.saved_attachment_type">
									<label class="control-label" ><i class="fas fa-circle-o"></i> {{ 'knowledge-with-attachment' | translate }}</label>
								</div>
								<hr>
							</div>

							<form @submit.prevent="replyIssue($event, issue.id)" v-if="!issue.reply">
								<div class="form__group form__group-relative">
									<label for="name">{{ 'answer' | translate | capitalize }}</label>
									<textarea id="send-message" @input="count($event, 1000)" maxlength="1000" v-model="response.reply" :disabled="this.selectedFile"></textarea>
									<span id="counter-send-message" class="label pull-right bg-red counter"></span>
								</div>

								<div class="form__group__uploader">
									<input type="text"  :placeholder="fileName" class="form__group__uploader--disabled" disabled>
									<label for="'upload-file" class="form__group__uploader__label">
										<input
										id="'upload-file"
										type="file"
										ref="fileupload"
										name="file"
										@change="handleFileUpload($event)"
										accept="image/*, video/*, audio/* video/mp4,video/x-m4v, .mov, .mp4, .x-m4v, .mp3, .png, .gif, .wav, .m4v"
										:disabled="this.response.reply.length > 0">
										<!-- {{ 'select' | translate | capitalize }} -->
										<span id="file-selected"></span>
									</label>
									<div v-if="this.selectedFile" @click="resetFile()" class="form__group__remove-attachment">
										<i class="fas fa-times"></i>
										{{ 'remove-attachment' | translate | titleCase }}
									</div>
								</div>
								<div class="has-error" v-if="errorMessage != ''">
									<label class="control-label" ><i class="fas fa-times-circle-o"></i>	{{ errorMessage }}</label>
								</div>

								<div class="form__group">
									<div class="image-preview" v-if="imageData.length > 0">
										<img class="preview" :src="imageData">
									</div>
								</div>

								<div class="form__group submit__content">
									<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
										{{ 'send' | translate | capitalize }}
									</button>
								</div>
								<div class="form__validation" v-show="apiError" v-for="(erro, index) in apiError" :key="index">
									<p><i class="fas fa-times-circle-o"></i> {{ erro | translate }}</p>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div class="box" hidden>
					<div class="box__container" v-if="issue">

						<div class="box__body">

							<div class="box__body__content__area" v-show="issue.reply">
								<div class="reply-message">
									<h2>{{ 'reply' | translate | capitalize }}</h2>
									<p>{{issue.reply}}</p>
								</div>
								<div v-if="issue.saved_attachment_id || issue.saved_attachment_type">
									<label class="control-label" ><i class="fas fa-circle-o"></i> {{ 'knowledge-with-attachment' | translate }}</label>
								</div>
								<hr>
							</div>

							<div v-if="issue.intents.length > 0">
								<div class="box__body__content__area" v-if="issue.intents.length > 1">
									<h2>{{ 'theme' | translate | capitalize }}</h2>

									<ul class="tags" v-if="groupsFilterToSendNotification">
										<li class="tags__tag" v-for="intents in issue.intents" :key="intents.tag">
											{{ intents.tag }}
										</li>
									</ul>
								<hr>
								</div>
							</div>

							<div class="box__body__content__area" v-if="issue.recipient.groups.length >= 1">
								<h2>{{ 'supporter-groups' | translate | capitalize }}</h2>
								<ul class="tags" v-if="issue.recipient.groups">
									<li class="tags__tag" v-for="issue in issue.recipient.groups" :key="issue.name">
										{{ issue.name }}
									</li>
								</ul>
							</div>
							<div class="box__body__content__area">
								<ul>
									<li>
										<button type="button" @click="allowAddToGroups" class="button--icon-with-text">
											{{ 'add-to-group' | translate | uppercase }}
										</button>
									</li>
								</ul>
							</div>

							<div v-show="showAddToGroups">
								<form @submit.prevent="addRecipientToGroups">
									<div class="form__group">
										<label for="groups">{{ 'select-groups' | translate | capitalize }}</label>
										<select class=" arrow-up" @change="controlGroupsSelected($event)" v-model="formRecipientToGroups">
											<option  :selected="(successMsg) ? true : null" >Escolha a segmentação</option>
											<option v-for="(group) in groups" :key="group.id" :value="group.id">{{group.name}}</option>
										</select>

										<div class="form__group">
											<ul class="tags" v-if="groupsFilterToSendNotification">
												<li class="tags__tag tags__tag--close" v-for="filter in groupsFilterToSendNotification" :key="filter.id">
													{{ filter.name }}
													<div class="tags__tag__close" @click="removeFilter(filter)">
														<i class="fas fa-times"></i>
													</div>
												</li>
											</ul>
											<span v-show="filterExists"> Esse filtro já foi inserido</span>

										</div>

										<div class="form__group submit__content">
											<button type="submit">
												{{ 'save' | translate }}
											</button>
										</div>
										<div class="text-center messages">
											<div class="form__group has-success has-message">
												<label class="control-label" for="inputSuccess" v-show="successMsg"><i class="fas fa-check"></i> {{ 'added-to-group' | translate | capitalize }}</label>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<div class="box__buttons">
					<ul>
						<li @click="$router.go(-1)">
							<button type="button">
								{{ 'back' | translate | uppercase }}
							</button>
						</li>
					</ul>
					<ul class="">
						<li v-show="issue.open">
							<button type="button" @click="ignoreIssue()">
								{{ 'delete' | translate | uppercase }}
							</button>
						</li>
						<li v-show="this.issue.read === 1 && !issue.reply">
							<button type="button" @click="toggleReadIssue()">
								{{ 'mark-as-not-read' | translate | uppercase }}
							</button>
						</li>
						<li v-show="issue.ignored">
							<button type="button" @click="deleteIssue()">
								{{ 'delete-permanently' | translate | uppercase }}
							</button>
						</li>
					</ul>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import modalGeneric from '../../components/modal/modalGeneric.vue';
	import recipientAvatar from '../../../images/avatar-recipient.jpg';

	export default {
		name: 'detailsMessage',
		components: {
			modalGeneric,
		},
		data() {
			return {
				loading: false,
				formRecipientToGroups: {},
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
					issueId: this.$route.params.id,
				},
				successMsg: false,
				filterExists: false,
				response: {
					reply: '',
				},
				confirm: false,
				showAddToGroups: false,
				groupId: [],
				groupsFilterToSendNotification: [],
				errorMessage: '',
				fileName: '',
				attachmentType: '',
				type: '',
				imageData: '',
				apiError: false,
				selectedFile: null,
				submitLoading: false,
				validationError: false,
			};
		},
		computed: {
			error() {
				return this.$store.state.error;
			},
			user() {
				return this.$store.state.user;
			},
			success() {
				return this.$store.state.status;
			},
			sucessSetGroup() {
				return this.$store.state.detailsMessage;
			},
			groups() {
				return this.$store.state.group.groups.groups;
			},
			issue() {
				return this.$store.state.issue.issue || {};
			},
			inactiveIntents() {
				const intents = (this.$store.state.issue.issue || {}).intents || {};
				return intents.filter(item => item.has_active_knowledge_base === 0);
			},
		},
		methods: {
			imageLoadOnError() {
				this.$refs.userUrl.src = recipientAvatar;
			},
			toggleLoading() {
				this.loading = !this.loading;
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			count(event, tam) {
				const lengthText = document.getElementById(`counter-${event.target.id}`);
				lengthText.textContent = (event.target.value.length - tam) * -1;
			},
			ignoreIssue() {
				this.confirm = true;
			},
			allowAddToGroups() {
				this.showAddToGroups = !this.showAddToGroups;
			},
			addRecipientToGroups() {
				const payload = {
					groupId: this.groupId,
					recipientId: this.issue.recipient.id,
					data: this.$data.formRecipientToGroups,
				};
				this.$store.dispatch('setRecipientToGroup', payload).then(() => {
					this.validate();
				});
			},
			handleFileUpload(event) {
				const input = event.target;
				const reader = new FileReader();

				this.imageData = '';
				if (input.files && input.files[0]) {
					this.fileSize = event.target.files[0].size;

					if (event.target.files[0].size < 26214400) {
						this.type = 'attachment';
						[this.selectedFile] = event.target.files;
						this.fileName = event.target.files[0].name;

						if ((/(image)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'image';
							reader.onload = (e) => {
								this.imageData = e.target.result;
							};
							reader.readAsDataURL(input.files[0]);
						} else if ((/(audio)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'audio';
						} else if ((/(video)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'video';
						} else {
							this.errorMessage = 'Formato inválido';
						}
					} else {
						this.errorMessage = 'O arquivo excede o tamanho máximo permitido';
						setTimeout(() => {
							this.errorMessage = '';
						}, 4000);
					}
				}
			},
			getFormData(object) {
				const formData = new FormData();
				Object.keys(object).forEach(key => formData.append(key, object[key]));
				return formData;
			},
			validate() {
				if (this.success) {
					this.successMsg = this.success;
					this.$data.formRecipientToGroups = {};
					setTimeout(() => {
						this.successMsg = false;
					}, 4000);
				}
			},
			resetFile() {
				this.$refs.fileupload.value = '';
				this.selectedFile = null;
				this.imageData = '';
				this.type = '';
				this.attachment_type = '';
				this.fileName = '';
			},
			replyIssue(event, id) {
				this.validate();
				const ignore = (event === 'ignore') ? 1 : 0;
				const payload = {};
				payload.issueId = id;

				if (event === 'ignore') {
					payload.ignore = ignore;
				}

				if (this.selectedFile) {
					payload.file = this.selectedFile;
					this.validationError = 'Anexar arquivos de mídia pode levar alguns minutos. Por favor, não feche esta janela enquanto estiver subindo mídia';
				}

				if (this.$data.response.reply) {
					payload.reply = this.$data.response.reply;
				}

				this.toggleSubmitLoading();
				this.$store.dispatch('responseIssue', this.getFormData(payload))
					.then(() => {
						this.validationError = '';
						this.toggleSubmitLoading();
						this.$router.push({ name: 'inbox' });
					})
					.catch((error) => {
						this.apiError = error.response.data.form_error;
						setTimeout(() => {
							this.apiError = false;
						}, 5000);
						this.validationError = '';
						this.toggleSubmitLoading();
					});
			},
			deleteIssue() {
				const payload = {};
				payload.issueId = this.$route.params.id;
				payload.deleted = 1;

				this.toggleSubmitLoading();
				this.$store.dispatch('responseIssue', this.getFormData(payload))
					.then(() => {
						this.toggleSubmitLoading();
						this.$router.push({ name: 'repliedMessages' });
					})
					.catch(() => {
						this.toggleSubmitLoading();
					});
			},
			controlGroupsSelected(event) {
				this.successMsg = false;
				let error = '';
				this.filterExists = false;
				error = this.groupsFilterToSendNotification.filter(p => p.id === event.target.value).length;
				if (error) {
					this.filterExists = true;
					return;
				}
				this.groupId.push(event.target.value);

				const index = event.target.options.selectedIndex;
				this.groupsFilterToSendNotification.push({
					name: event.target.options[index].textContent,
					id: event.target.value,
				});
			},
			removeFilter(obj) {
				this.groupsFilterToSendNotification.splice(obj, 1);
				this.filterExists = false;
			},
			getMessage() {
				this.$root.$on('close', () => {
					this.confirm = false;
					this.confirmDelete = false;
				});
				const session = { apiKey: sessionStorage.getItem('apiKey'), userId: sessionStorage.getItem('userId') };
				this.$store.dispatch('getGroups', session);
				if (this.$route.params.id) {
					this.toggleLoading();
					this.$store.dispatch('geIssuebyid', this.session)
						.then(() => {
							this.toggleLoading();
							this.openIssue();
						})
						.catch(() => {
							this.toggleLoading();
						});
				} else {
					this.$router.push({ path: '/mensagens' });
				}
			},
			openIssue() {
				if (this.issue.read === 0) {
					const payload = {};
					payload.read = 1;
					payload.issueId = this.$route.params.id;

					this.issue.read = 1;
					this.$store.dispatch('toggleReadIssue', payload);
				}
			},
			toggleReadIssue() {
				if (this.issue.read === 0) {
					const payload = {};
					payload.read = 1;
					payload.issueId = this.$route.params.id;

					this.$store.dispatch('toggleReadIssue', payload);
				}

				if (this.issue.read === 1) {
					const payload = {};
					payload.read = 0;
					payload.issueId = this.$route.params.id;

					this.$store.dispatch('toggleReadIssue', payload);
					this.$router.push({ name: 'inbox' });
				}
			},
		},
		mounted() {
			this.getMessage();
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/issue/messageDetails.vue